import { Handle, Position, useReactFlow, type Edge } from '@xyflow/react';
import { BaseNode } from '@/components/base-node';
import { useTranslation } from 'react-i18next';

type MessageNodeData = { message?: string };

const MessageNode = ({ id, data }: { id: string; data: MessageNodeData }) => {
  const { setNodes, setEdges } = useReactFlow();
    const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newMessage = e.target.value;

    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id ? { ...node, data: { ...node.data, message: newMessage } } : node
      )
    );
  };

  return (
    <BaseNode>
      <Handle type="target" position={Position.Top} />
      <div className="p-4">
        <p className="font-bold">{t('sendMessage')}</p>
        <textarea
          rows={3}
          value={data.message}
          onChange={handleChange}
          className="w-full rounded-md border border-gray-300 p-2"
          placeholder="Escribe el mensaje de respuesta..."
        />
        <div className="mt-2">
          <button
            onClick={() => {
              setEdges((eds: Edge[]) => eds.filter((e) => e.source !== id && e.target !== id));
              setNodes((nodes) => nodes.filter((n) => n.id !== id));
            }}
            className="text-red-600 px-2 py-1 text-sm border border-red-300 rounded"
          >
            {t('deleteNode')}
          </button>
        </div>
      </div>
      <Handle type="source" position={Position.Bottom} />
    </BaseNode>
  );
};

export default MessageNode;
